import { getFieldsValues, insertColor } from "../helper";
import { ComponentProps, MyStyles } from "../template.interface";

export default function TemplateOverlayAnchorBox(props: ComponentProps) {
  const {
    id = "",
    children = null,
    styles = {},
    componentProps = {},
    values = {},
    fields = { static: {}, dynamic: {} },
    content = {},
    isEdit,
  } = props;
  const { url } = getFieldsValues(content, values, fields, isEdit);
  return (
    <div
      style={{ ...insertColor(styles as MyStyles, values, fields, isEdit) }}
      {...componentProps}
    >
      <a
        href={url}
        rel="noreferrer"
        target="_blank"
        style={{
          all: "initial",
          display: "block",
          width: "100%",
          height: "100%",
          position: "absolute",
          // The served click layer's z-index (backend `generateHtml.js`, overlayAnchorBox).
          zIndex: 20,
          cursor: "pointer",
          background: "none",
        }}
      />
      {/*
        The served ad's `#mys-overlay`: a 1px #E5E5E5 frame drawn inside the ad, over the art edge.
        A data attribute rather than the id, so a page of previews does not repeat an id.
      */}
      <div
        data-tpl-frame="served"
        style={{
          height: "100%",
          width: "100%",
          overflow: "hidden",
          position: "absolute",
          top: 0,
          left: 0,
          boxSizing: "border-box",
          pointerEvents: "none",
          zIndex: 5,
          border: "1px solid #E5E5E5",
        }}
      />
      {children}
    </div>
  );
}
